// extracted by mini-css-extract-plugin
export default {"root":"list_root__oC2cP"};